import { render, staticRenderFns } from "./parent-view.vue?vue&type=template&id=54942a1a"
import script from "./parent-view.vue?vue&type=script&lang=ts"
export * from "./parent-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports